import React from "react";
import Topbar from "./components/Topbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Stack from "./components/Stack";
import Timeline from "./components/Timeline";
import Credentials from "./components/Credentials";
import Systems from "./components/Systems";
import Quotes from "./components/Quotes";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import useGithubStats from "./hooks/useGithubStats";

export default function App() {
  const github = useGithubStats();

  return (
    <>
      <Topbar />
      <main>
        <Hero />
        <About />
        <Timeline />
        <Stack />
        <Credentials />
        <Systems />
        <Quotes />
        <Contact github={github} />
        <Footer />
      </main>
    </>
  );
}
